import React from 'react';
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';
import Footer from "../../homepage/footer"

const ExamBoardSelection = () => {
    const navigate = useNavigate();

    return (
        <div className="flex flex-col min-h-screen bg-gray-50 font-sans">
            <Helmet>
                <title>Exam Papers | MLMaths</title>
                <link rel="canonical" href="https://mlmaths.co.uk/examboard" />
                <meta name="description" content="Access past GCSE Maths exam papers from AQA, Edexcel, OCR, and Eduqas to practice and prepare for your exams." />
            </Helmet>
            {/* Main Content */}
            <main className="container mx-auto py-10 px-4 sm:px-6 lg:px-12 max-w-7xl flex-grow">
                {/* Header Section */}
                <div className="text-center mb-10">
                    <div className="bg-teal-100 w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-4">
                        <svg className="w-10 h-10 text-teal-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                        </svg>
                    </div>
                    <h1 className="text-4xl font-bold text-gray-800 mb-2">Select Your Exam Board</h1>
                    <p className="text-lg text-gray-600">Choose your exam board to access past papers for GCSE Maths</p>
                </div>

                {/* Cards Section */}
                <section className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-5xl mx-auto">
                    {/* AQA Card */}
                    <div
                        className="bg-white rounded-2xl shadow-xl p-6 cursor-pointer hover:shadow-2xl transition-all border-t-4 border-teal-500"
                        onClick={() => navigate('/aqa')}
                    >
                        <div className="bg-teal-100 w-16 h-16 rounded-full flex items-center justify-center mb-4">
                            <svg className="w-8 h-8 text-teal-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                            </svg>
                        </div>
                        <h3 className="text-xl font-bold text-gray-800 mb-2">AQA</h3>
                        <p className="text-gray-600">
                            Access all AQA past papers and resources.
                        </p>
                    </div>

                    {/* Edexcel Card */}
                    <div
                        className="bg-white rounded-2xl shadow-xl p-6 cursor-pointer hover:shadow-2xl transition-all border-t-4 border-teal-500"
                        onClick={() => navigate('/edexcel')}
                    >
                        <div className="bg-teal-100 w-16 h-16 rounded-full flex items-center justify-center mb-4">
                            <svg className="w-8 h-8 text-teal-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                            </svg>
                        </div>
                        <h3 className="text-xl font-bold text-gray-800 mb-2">Edexcel</h3>
                        <p className="text-gray-600">
                            Access all Edexcel past papers and resources.
                        </p>
                    </div>

                    {/* OCR Card */}
                    <div
                        className="bg-white rounded-2xl shadow-xl p-6 cursor-pointer hover:shadow-2xl transition-all border-t-4 border-teal-500"
                        onClick={() => navigate('/ocr')}
                    >
                        <div className="bg-teal-100 w-16 h-16 rounded-full flex items-center justify-center mb-4">
                            <svg className="w-8 h-8 text-teal-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                            </svg>
                        </div>
                        <h3 className="text-xl font-bold text-gray-800 mb-2">OCR</h3>
                        <p className="text-gray-600">
                            Access all OCR past papers and resources.
                        </p>
                    </div>
                </section>
            </main>

            {/* Footer */}
            <Footer />
        </div>
    );
};

export default ExamBoardSelection;
